/* eslint-disable indent */
import styled from 'styled-components';
import colors from '../../../../assets/colors';

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  margin-bottom: ${props => (props.selected ? 0 : '15px')};
  background-color: ${colors.white};
  border-radius: 8px;
  border-bottom-left-radius: ${props => (props.selected ? 0 : '8px')};
  border-bottom-right-radius: ${props => (props.selected ? 0 : '8px')};
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;

  .row {
    width: 140px;

    h2 {
      display: none;
      font-size: 0.9rem;
      font-weight: 700;
      color: #000;
    }

    p, .date {
      font-size: 0.9rem;
      font-weight: 400;
      color: #000;
    }

    .date {
      color: #999;
      text-transform: uppercase;
    }
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;

    .row {
      width: 100%;
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 1px solid #E9E9E9;

      h2 { display: block }
    }

    .last-row {
      margin-bottom: 10px;
      border: none;
    }
  }
`;

export const Button = styled.button`
  width: 125px;
  padding: 8px 0;
  background: ${colors.primary};
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;
  cursor: pointer;

  span { margin-right: 5px }
  .fa-angle-down, .fa-angle-up { font-size: 1.0rem; margin-bottom: -3px; }

  :hover { opacity: .9 }

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 11px 0;
  }
`;

export const Details = styled.div`
  display: ${props => (props.selected ? 'block' : 'none')};
  margin-top: -3px;
  margin-bottom: 15px;
  background-color: #FDFDFD;
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  .spacer {
    background-repeat: repeat-x;
    width: 100%;
    height: 15px;
  }

  .container {
    padding: 5px 20px 20px;
    display: flex;

    .row { flex: 1 }
  }

  p {
    font-size: 0.9rem;
    font-weight: 400;
    color: #000;
    margin-bottom: 3px;

    span {
      font-size: 0.9rem;
      font-weight: 700;
      color: #000;
      letter-spacing: -0.5px;
      padding-right: 5px;
    }

    span.status {
      color: ${(props) => {
        if (props.status === 'Complete') return `${colors.primary}`;
        if (props.status === 'Cancelled') return `${colors.red}`;
        return '#000';
      }};
    }

    :last-child { margin-bottom: 0 }
  }

  @media screen and (max-width: 767px) {
    .container {
      flex-direction: column;

      .row:first-child { margin-bottom: 15px }
    }
  }
`;
